module.exports = __webpack_public_path__ + "img/telegraphs-frame.1f3ad92d.gif";